export enum Actions {
  MANAGE = 'manage', // Create, Update, Delete etc
  CREATE = 'create',
  READ = 'read', // Map to "View"
  LIST = 'list',
  SUBMIT = 'submit',
  UPDATE = 'update', // Map to "Edit"
  DELETE = 'delete', // Map to "Delete/Archive"
  APPROVE = 'approve',
  VERIFY = 'verify',
  DECLINE = 'decline', // Map to "Reject/Deny"
  CANCEL = 'cancel',
  PUSH_BACK = 'push_back',
  INVITE = 'invite',
  EXPORT = 'export',
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  SYNC = 'sync',
  BULK_UPLOAD = 'bulk_upload',
  PUBLISH = 'publish',
  SHARE = 'share',
  COMPLETE = 'complete',
  LOG_DELIVERY = 'log_delivery',
  ALL = 'all',
}
